import React from "react";
import { Stack, Typography } from "@mui/material";
import LogoIcon from "components/icon/LogoIcon";
import { useTranslation } from "react-i18next";

const Logo = (props) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction={"row"}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        width: "100%",
        height: 40
      }}>
      {/* <img src={`${logo}`}  alt="logo" width={`100%`} /> */}
      <LogoIcon sx={{ fontSize: 34 }} />
      <Typography variant="h3" sx={{ color: "#101828" }}>
        {t("campusGuardianAngel")}
      </Typography>
    </Stack>
  );
};

export default Logo;
